import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const FallbackUserFieldPropTypes = {
  value: PropTypes.string,
  settingsLink: PropTypes.string
};
const FallbackUserField = ({
  value,
  settingsLink
}) => {
  return /*#__PURE__*/_jsx(UIFormControl, {
    tooltip: I18n.text('data-token-picker.fallbackUserTooltip'),
    tooltipPlacement: "bottom right",
    label: I18n.text('data-token-picker.fallbackUserLabel'),
    help: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "data-token-picker.fallbackUserLabelHelp",
      options: {
        href: settingsLink
      }
    }),
    children: /*#__PURE__*/_jsx(UITextInput, {
      "data-test-id": "global-user-fallback-input",
      disabled: true,
      value: value || ''
    })
  });
};
FallbackUserField.propTypes = FallbackUserFieldPropTypes;
FallbackUserField.displayName = 'FallbackUserField';
export default FallbackUserField;